'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getParametersSaga;

var _effects = require('redux-saga/effects');

var _cookiesJs = require('cookies-js');

var _cookiesJs2 = _interopRequireDefault(_cookiesJs);

var _setParametersSaga = require('./setParametersSaga');

var _setParametersSaga2 = _interopRequireDefault(_setParametersSaga);

var _selectParameters = require('../../selectors/context/selectParameters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getParametersSaga);

function getParametersSaga() {
	var parameters, jsonCookie, cookie;
	return regeneratorRuntime.wrap(function getParametersSaga$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					_context.next = 2;
					return (0, _effects.select)((0, _selectParameters.selectParameters)());

				case 2:
					parameters = _context.sent;

					if (parameters.length) {
						_context.next = 10;
						break;
					}

					jsonCookie = _cookiesJs2.default.get('_metrix');
					cookie = null;

					if (jsonCookie) {
						cookie = JSON.parse(jsonCookie);
					}

					if (!(cookie && cookie.parameters)) {
						_context.next = 10;
						break;
					}

					_context.next = 10;
					return (0, _setParametersSaga2.default)({ payload: cookie.parameters });

				case 10:
					return _context.abrupt('return', parameters);

				case 11:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked, this);
}